import { Injectable } from '@angular/core';
import { TourService } from 'ngx-ui-tour-core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductTourService {
  private readonly _displayHelp$: BehaviorSubject<boolean> =
    new BehaviorSubject(false);

  constructor(private readonly tourService: TourService) {}

  setDisplayHelp(value: boolean) {
    this._displayHelp$.next(value);
  }

  get displayHelp$() {
    return this._displayHelp$;
  }
}
